import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  Inject,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { Item } from "@va/core-library/item-picker/item-picker-model";
import {
  DEFAULT_RANGE_PERIOD_FILTER_DATA,
  getSelectedPeriodBasis,
} from "@va/core-library/period-filter";
import {
  getSelectedPeriods,
  getPeriodTypeDataId,
} from "src/app/utils/period-utils";
import { PharmaDataService } from "../pharma-data.service";
import { DOCUMENT } from "@angular/common";
import { AppService } from "src/app/app.service";
import { Router } from "@angular/router";
import { DatabasePageSiderComponent } from "../database-page-sider/database-page-sider.component";
import { Subscription } from "rxjs";
@Component({
  selector: "app-database-grid-controls",
  templateUrl: "./database-grid-controls.component.html",
  styleUrls: ["./database-grid-controls.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DatabaseGridControlsComponent
  implements OnInit, OnDestroy, OnChanges
{
  defaultPeriodObj = DEFAULT_RANGE_PERIOD_FILTER_DATA;
  //object to emit
  periodObj = {
    period: [],
    periodStart: -2,
    periodEnd: 7,
    period_type: "absolute",
    period_basis: "calendar",
  };
  periodMinMax = {
    min: -15,
    max: 25,
  };
  columnList = [];
  dataView: { view_by: any[]; revision?: string };
  revenueType;
  revenueTypeOptions = [
    {
      value: "total_revenue",
      label: "Adjusted",
    },
    {
      value: "gross_revenue",
      label: "Unadjusted",
    },
  ];
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: true,
    },
  ];
  isExportPopoverVisible = false;
  isExportInProgress = false;
  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  selectedCurrency;
  currencyDisabled = false;
  apiEP: string = window.apiUrl;
  dataCallSubscriber: Subscription;
  constructor(
    private pharmaDataService: PharmaDataService,
    private databasePageSiderCompanent: DatabasePageSiderComponent,
    private appService: AppService,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {}
  @Output() columnListChanged: EventEmitter<any> = new EventEmitter();
  @Output() periodChanged: EventEmitter<any> = new EventEmitter();
  @Output() dataSettingsChanges: EventEmitter<any> = new EventEmitter();
  @Output() defaultSettingsApplied: EventEmitter<any> = new EventEmitter();
  @Output() indicationBreakoutChanged: EventEmitter<any> = new EventEmitter();
  @Input() indicationBreakout;
  @Output() showNIBChanged: EventEmitter<any> = new EventEmitter();
  @Input() showNIB;
  @Input() disableNIBControl;
  @Input() indicationBreakoutContol;
  @Input() facetFilters;
  @Input() totalCount;
  @Input() consolidatedCount;
  @Input() fullExportFlag;
  ngOnInit() {
    this.defaultPeriodObj = {
      is_annual_selected: true,
      period_basis: {
        abs: {
          from_basis: [
            {
              label: "",
              name: "Y",
              selected: true,
            },
          ],
          to_basis: [
            {
              label: "",
              name: "Y",
              selected: true,
            },
          ],
        },
        rel: {
          from_basis: [
            {
              label: "",
              name: "Y",
              selected: false,
            },
          ],
          to_basis: [
            {
              label: "",
              name: "Y",
              selected: false,
            },
          ],
        },
      },
      basis: [
        {
          label: "Calendar",
          name: "cal",
          selected: true,
        },
        {
          label: "Fiscal",
          name: "fy",
          selected: false,
        },
      ],
      from_to: {
        selected_from: new Date().getFullYear() - 2,
        selected_to: new Date().getFullYear() + 7,
      },
      other_period: [],
      type: [
        {
          label: "Absolute",
          name: "abs",
          selected: true,
        },
        {
          label: "Relative",
          name: "rel",
          selected: false,
        },
      ],
    };
    const selectedPeriodList = getSelectedPeriods(this.defaultPeriodObj, false);
    const periodType = getPeriodTypeDataId(this.defaultPeriodObj);
    const basisValue =
      getSelectedPeriodBasis(this.defaultPeriodObj.basis) === "cal"
        ? "calendar"
        : "fiscal";
    this.periodObj = {
      period: selectedPeriodList,
      periodStart: -2,
      periodEnd: 7,
      period_type: periodType,
      period_basis: basisValue,
    };
    this.columnList = ["indications", "moa", "lines"];
    this.dataView = {
      view_by: ["values"],
      revision: "",
    };
    this.updateExcelExportOptions();
    this.revenueType = "total_revenue";
    this.selectedCurrency = this.pharmaDataService.defaultCurrency;
    this.defaultSettingsApplied.emit({
      period: this.periodObj,
      currency: this.pharmaDataService.defaultCurrency,
      columnList: this.columnList,
      dataView: {
        viewBy: this.dataView.view_by[0],
        revision: this.dataView.revision,
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.facetFilters) {
      this.updateExcelExportOptions();
    }
  }

  onColumnPickerChange(selectedItems: Item[]) {
    this.columnList = [...selectedItems];
    this.columnListChanged.emit(selectedItems);
    this.pharmaDataService.logUserAction("COLUMN_LIST_CHANGED", {
      column_list: this.columnList,
    });
  }

  periodSettingsChange(param) {
    const { updatedPeriodData, periodUserSettingData } = param;
    const selectedPeriodList = getSelectedPeriods(
      param.updatedPeriodData,
      false,
    );
    const periodType = getPeriodTypeDataId(updatedPeriodData);
    const basisValue =
      getSelectedPeriodBasis(updatedPeriodData.basis) === "cal"
        ? "calendar"
        : "fiscal";

    this.periodObj.period = selectedPeriodList;
    this.periodObj.period_basis = basisValue;
    this.periodObj.period_type = periodType;
    this.periodObj.periodStart = periodUserSettingData.from;
    this.periodObj.periodEnd = periodUserSettingData.to;
    this.defaultPeriodObj = updatedPeriodData;
    this.periodChanged.emit(this.periodObj);
  }

  updateDataView($event) {
    this.dataView = { view_by: $event.viewBy, revision: $event.revision };
    this.updateExcelExportOptions();
    this.dataSettingsChanges.emit({
      viewBy: $event.viewBy[0],
      revision: $event.revision,
      currency: this.selectedCurrency === "Base" ? "" : this.selectedCurrency,
    });
  }
  updateExcelExportOptions() {
    this.excelToExportDropdownOptions[1].disabled = !(
      this.dataView?.view_by[0] === "values" ||
      this.dataView?.view_by[0] === "yoy"
    );
    if (this.facetFilters["geo"].length) {
      this.excelToExportDropdownOptions[1].disabled = true;
    }
  }
  onCurrencyChange(currency) {
    this.selectedCurrency = currency;
    this.dataSettingsChanges.emit({
      currency: this.selectedCurrency === "Base" ? "" : this.selectedCurrency,
    });
  }
  indicationBreakoutChange() {
    this.indicationBreakoutChanged.emit(this.indicationBreakout);
    this.pharmaDataService.logUserAction(
      this.indicationBreakout
        ? "INDICATION_BREAKDOWN_TOGGLE_ON"
        : "INDICATION_BREAKDOWN_TOGGLE_OFF",
      {},
    );
  }
  showNIBChange(newNIB) {
    this.showNIBChanged.emit(newNIB);
    // this.pharmaDataService.logUserAction(
    //   this.showNIB
    //     ? "SHOW_NIB_CHECKBOX_SELECTED"
    //     : "SHOW_NIB_CHECKBOX_UNSELECTED",
    //   {},
    // );
  }
  onRevenueTypeChange() {
    this.columnList = [...new Set([...this.columnList, "risk_type"])];
    this.columnListChanged.emit(this.columnList);
    this.dataSettingsChanges.emit({
      revenue_type: this.revenueType,
      column_list: this.columnList,
    });
  }

  /**
   * Executes on click of export dropdown list item
   * It closes the dropdown on selecting list items. Also one can update the loader status when excel to export action is in progress
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleETEListItemClick(exportType) {
    this.isExportInProgress = true;
    const templateType = "drug dashboard";
    const payload = sessionStorage.getItem("payload");
    const url = this.router.url.split("/");
    let filterId = url.slice(-1)[0];
    if (isNaN(Number(filterId))) {
      filterId = "";
    }
    this.pharmaDataService.excelExportSource.next();
    const params = `export_type=${exportType}&template_type=${templateType}&filter=${filterId}&breakout=${this.indicationBreakout}`;
    const fullExportParams = `export_type=${exportType}&template_type=${templateType}&filter=${filterId}&breakout=${this.indicationBreakout}&add_debug_info=${true}`;
    if (
      !this.indicationBreakout &&
      (!this.fullExportFlag || this.totalCount <= 500)
    ) {
      this.dataCallSubscriber = this.pharmaDataService
        .exportDrugDashboard(payload, params)
        .subscribe(
          (res) => {
            if (res["status"] === "success") {
              const fileName = res["filename"];
              const trackerId = res["trackerid"];
              const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
              const startIFrameTime = new Date().getTime();
              const iFrameToLoad = this._document.createElement("iframe");
              const body = this._document.getElementsByTagName("body")[0];
              iFrameToLoad.id = `${fileName}`;
              iFrameToLoad.name = `${fileName}`;
              iFrameToLoad.src = downloadUrl;
              iFrameToLoad.setAttribute(
                "style",
                "visibility:hidden;display:none",
              );
              body.appendChild(iFrameToLoad);

              const checkInterval = setInterval(() => {
                const iFrameToGet = this._document.getElementById(
                  `${fileName}`,
                ) as HTMLIFrameElement;
                const iFrame =
                  iFrameToGet.contentDocument ||
                  iFrameToGet.contentWindow.document;
                /*
            This check will run till the iFrame either doesn't load or for a max of 30secs
            Or till the ready state of the iFrame doesn't evaluate
          */
                if (
                  iFrame.readyState === "complete" ||
                  iFrame.readyState === "interactive" ||
                  new Date().getTime() - startIFrameTime > 30000
                ) {
                  clearInterval(checkInterval);
                  return;
                }
              }, 2000);
              this.isExportInProgress = false;
              this.pharmaDataService.logUserAction("EXCEL_TRACKER", {
                templateType: templateType,
                export_type: exportType,
                tracker_id: trackerId,
                file_name: fileName,
              });
            } else {
              this.isExportInProgress = false;
              this.snackbarInfo.message =
                "Drug Dashboard export couldn't be downloaded.";
              this.snackbarInfo.type = "failure";
            }
          },
          (err) => {
            this.isExportInProgress = false;
            console.error(err);
          },
        );
    } else if (
      this.indicationBreakout ||
      (!this.indicationBreakout && this.fullExportFlag && this.totalCount > 500)
    ) {
      this.pharmaDataService
        .exportFullDrugDashboard(payload, fullExportParams)
        .subscribe(
          (res) => {
            if (res["status"] === "success") {
              const fileName = res["filename"];
              const trackerId = res["trackerid"];
              // const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
              const startIFrameTime = new Date().getTime();
              const iFrameToLoad = this._document.createElement("iframe");
              const body = this._document.getElementsByTagName("body")[0];
              iFrameToLoad.id = `${fileName}`;
              iFrameToLoad.name = `${fileName}`;
              // iFrameToLoad.src = downloadUrl;
              iFrameToLoad.setAttribute(
                "style",
                "visibility:hidden;display:none",
              );
              body.appendChild(iFrameToLoad);

              const checkInterval = setInterval(() => {
                const iFrameToGet = this._document.getElementById(
                  `${fileName}`,
                ) as HTMLIFrameElement;
                const iFrame =
                  iFrameToGet.contentDocument ||
                  iFrameToGet.contentWindow.document;
                /*
            This check will run till the iFrame either doesn't load or for a max of 30secs
            Or till the ready state of the iFrame doesn't evaluate
          */
                if (
                  iFrame.readyState === "complete" ||
                  iFrame.readyState === "interactive" ||
                  new Date().getTime() - startIFrameTime > 30000
                ) {
                  clearInterval(checkInterval);
                  return;
                }
              }, 2000);
              this.isExportInProgress = false;
              this.pharmaDataService.logUserAction("EXCEL_TRACKER", {
                templateType: templateType,
                export_type: exportType,
                tracker_id: trackerId,
                file_name: fileName,
              });
            } else {
              this.isExportInProgress = false;
              this.snackbarInfo.message =
                "Drug Dashboard export couldn't be downloaded.";
              this.snackbarInfo.type = "failure";
            }
          },
          (err) => {
            this.isExportInProgress = false;
            console.error(err);
          },
        );
    }
  }

  ngOnDestroy(): void {
    if (this.dataCallSubscriber) {
      this.dataCallSubscriber.unsubscribe();
    }
  }
}
